import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import { Placement } from '@popperjs/core';

import { EditStrongIcon, DotMenuStrongIcon } from 'src/monet/icons';
import { TooltipComponent } from 'src/common/tooltip/component';
import { ShareAdditionalLinkItemMenu } from './item-menu';
import { useShareThumbnailCodeStore } from '../../../thumbnail-code/store';

interface Props {
  onEditLinkClick: () => void;
  onCopyThumbnailClicked: () => void;
  onDeleteConfirm: () => void;
}

export const ShareAdditionalLinkItemHoverMenu = ({
  onEditLinkClick,
  onCopyThumbnailClicked,
  onDeleteConfirm,
}: Props) => {
  const resetThumbnailElement = useShareThumbnailCodeStore((state) => state.resetThumbnailElement);
  const menuPlacementRef = useRef<Placement>('bottom-end');

  const [keepMenuOpen, setKeepMenuOpen] = useState(false);

  const onMenuOpened = (placement?: Placement) => {
    menuPlacementRef.current = placement || menuPlacementRef.current;
    setKeepMenuOpen(true);
  };

  const onMenuClosed = () => {
    resetThumbnailElement();
    setKeepMenuOpen(false);
  };

  return (
    <div
      className={classNames({
        'hidden group-hover/row:block': !keepMenuOpen,
        block: keepMenuOpen,
      })}
    >
      <div className='flex items-center space-x-sm h-5 text-bedrock-black'>
        <TooltipComponent placement='top' tooltipContent='Edit link' styling='tooltip' theme='journey'>
          <div className='cursor-pointer hover:opacity-80' onClick={onEditLinkClick}>
            <EditStrongIcon />
          </div>
        </TooltipComponent>
        <ShareAdditionalLinkItemMenu
          placement={menuPlacementRef.current}
          renderOrigin={() => (
            <div className='cursor-pointer hover:opacity-80'>
              <DotMenuStrongIcon />
            </div>
          )}
          onMenuClose={onMenuClosed}
          onMenuOpen={onMenuOpened}
          onCopyThumbnailClick={onCopyThumbnailClicked}
          onDeleteConfirm={onDeleteConfirm}
        />
      </div>
    </div>
  );
};
